import { Injectable } from '@angular/core';
import { IAction } from '../domain/IAction';
import { SYSTEM_ACTION_ROLES_ENUM } from '../domain/enums/system-action-roles.enum';
import { AuthService } from '../core/services/auth.service';
import { hasLegacyRoleFallback } from './permissions/legacy-role-fallback';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private authService: AuthService) { }

  get systemActionRoles() {
    return SYSTEM_ACTION_ROLES_ENUM;
  }

  public is(role: SYSTEM_ACTION_ROLES_ENUM): boolean {
    return this.hasPermission({ role });
  }

  public getPermissions() {
    try {
      const permissionsStr = window.localStorage.getItem('@gmt:permissions');
      if (!permissionsStr || permissionsStr.trim() === '') {
        return null;
      }
      const permissions = JSON.parse(permissionsStr);
      return permissions;
    } catch (error) {
      console.error('Erro ao fazer parse das permissões:', error);
      // Limpar localStorage corrompido
      window.localStorage.removeItem('@gmt:permissions');
      return null;
    }
  }

  public hasPermission(action: IAction): boolean {
    try {
      const permissions = this.getPermissions();
      if (permissions && Array.isArray(permissions)) {
        const permission = permissions.find((p: string) => p === action.role);
        // Regra N1: role propria OU, na transicao, a role legada da qual foi desmembrada.
        return permission ? true : hasLegacyRoleFallback(permissions, action.role);
      }
      return false;
    } catch (error) {
      console.error('Erro ao verificar permissão:', error);
      return false;
    }
  }

  isDevUser(): boolean {
    const user = this.authService.getUser();
    return user?.role === 'DEV';
  }
}
